import { c as _c } from "react/compiler-runtime";
import type { ApiCicOverview } from "@/generated/models/ApiCicOverview";
import type { ApiIdentity } from "@/generated/models/ApiIdentity";
import UserPageIdentityHeaderCIC from "./UserPageIdentityHeaderCIC";
export default function UserPageIdentityHeader(t0) {
  const $ = _c(4);
  const {
    profile,
    cicOverview
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="tw-mb-6"><h2 className="tw-mb-1 tw-text-xl tw-font-semibold tw-text-iron-100">Network Identity Check (NIC)</h2><p className="tw-mb-0 tw-text-sm tw-font-normal tw-leading-relaxed tw-text-iron-500">Does the network believe this profile accurately represents its identity?</p></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== cicOverview || $[2] !== profile) {
    t2 = <div className="tw-px-6 tw-pt-6">{t1}<UserPageIdentityHeaderCIC profile={profile} cicOverview={cicOverview} /></div>;
    $[1] = cicOverview;
    $[2] = profile;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}